"use client";

import { useState } from "react";
import Image from "next/image";
import DealHeroFilm from "@/components/deals/DealHeroFilm";
import { dealFilmUit, useDealFilms } from "@/lib/dealfilm";

// Filmkop van de categoriepagina (Dennis 28-10-2026): een band over de volle
// breedte die onder de doorzichtige kopbalk doorloopt, zoals de homepagekop,
// maar lager zodat de eerste rij aanbiedingen hoog blijft. De poster is het
// LCP-element en wordt op de server gerenderd; de film komt pas na het laden
// uit het register. De film is een sfeerfilm van de categorie: eerst de eigen
// categoriefilm uit het register (sleutel categorie:<categorieSleutel>, als die
// een kopfilm heeft); anders de eerste deal in de standaardvolgorde met een
// kopfilm. Hij verandert niet bij filteren of sorteren.

function idKey(id) {
  return String(id).trim();
}

export default function CategoryFilmKop({
  posterSrc = null,
  posterAlt = "",
  dealIds = [],
  uitgeslotenIds = [],
  categorieSleutel = null,
  children,
}) {
  const dealFilms = useDealFilms();
  const [stopSlot, setStopSlot] = useState(null);

  const uitgesloten = new Set(uitgeslotenIds.map(idKey));
  // Alleen een registerfilm met een kopfilm (`hero` of `band`, de velden van
  // DealHeroFilm) telt; een vermelding met alleen `kaart` wordt overgeslagen.
  const heeftKopFilm = (id) => {
    const film = dealFilmUit(dealFilms, id);
    return !!(film && (film.hero || film.band));
  };
  const categorieFilmId = categorieSleutel ? `categorie:${categorieSleutel}` : null;
  const dealFilmId =
    dealIds.find((id) => id != null && id !== "" && !uitgesloten.has(idKey(id)) && heeftKopFilm(id)) ?? null;
  const filmDealId = categorieFilmId && heeftKopFilm(categorieFilmId) ? categorieFilmId : dealFilmId;

  return (
    <div
      data-testid="category-film-kop"
      className="relative overflow-hidden -mt-[70px] lg:-mt-[106px] min-h-[300px] md:min-h-[380px] lg:min-h-[440px] flex flex-col justify-end bg-[#1f2a37]"
    >
      {posterSrc && (
        <Image
          src={posterSrc}
          alt={posterAlt}
          fill
          priority
          sizes="100vw"
          quality={60}
          className="object-cover"
        />
      )}
      {filmDealId != null && <DealHeroFilm dealsId={filmDealId} plek="categorie" stopSlot={stopSlot} />}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{ background: "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.55) 100%)" }}
      />
      {/* Eigen plek voor "Beweging uit": rechtsboven onder de kopbalk, nooit onder het logo of menu.
          Boven de tekstlaag (z-20 tegen z-10) zodat de knop tikbaar blijft; de knop heeft zelf pointer-events-auto. */}
      <div
        ref={setStopSlot}
        data-testid="category-film-stop-slot"
        className="pointer-events-none absolute z-20 right-0 top-[78px] lg:top-[114px] w-[180px] h-[60px]"
      />
      {/* Tekstlaag vangt geen klikken af; alleen de h1-rij met favorietknop is weer klikbaar. */}
      <div
        data-testid="category-film-tekstlaag"
        className="pointer-events-none relative z-10 w-full max-w-[1320px] mx-auto px-4 pb-6 lg:pb-8 pt-[100px] lg:pt-[140px]">
        <div className="pointer-events-auto">{children}</div>
      </div>
    </div>
  );
}
